import { render, staticRenderFns } from "./lastcyclequeen.vue?vue&type=template&id=50c35827&"
import script from "./lastcyclequeen.vue?vue&type=script&lang=js&"
export * from "./lastcyclequeen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports